import React, { useState, useEffect, useRef } from 'react'
import './RankingCharts.css'
//components
import DashboardFilter from '../fragments/DashboardFilter'
import Ranking from '../../../components/Ranking/Ranking'
//services
import { dashboardService } from '../../../services/Dashboard';
//utils
import { formatShortDate, getMonth } from '../../../utils/utils';

const RankingCharts = () => {
  const chartRef = useRef(null);
  const [topProviders, setTopProviders] = useState([]);
  const [topCustomers, setTopCustomers] = useState([]);

  useEffect(() => {
    fetchTopProviders();
    fetchTopCustomers();
  }, []);

  const fetchTopProviders = async (filters = {}) => {
    try {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 1);
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        limit: 10,
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.topProviders(params);
      console.log(response)
      if(response && response.results && response.results.length > 0){
        setTopProviders(response.results);
      }else{
        setTopProviders([]);
      }
    } catch (error) {
      console.error('Error fetching top providers:', error);
    }
  };

  const fetchTopCustomers = async (filters = {}) => {
    try {
      const date = new Date();
      date.setFullYear(date.getFullYear() - 1);
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        limit: 10,
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.topCustomers(params);
      if(response && response.results && response.results.length > 0){
        setTopCustomers(response.results);
      }else{
        setTopCustomers([]);
      }
    } catch (error) {
      console.error('Error fetching top customers:', error);
    }
  };

  return (
    <div className="ranking-charts-container">
      <DashboardFilter 
        chartRef={chartRef}
        section="rankings"
        onApplyFilters={(filters) => {
          fetchTopProviders(filters);
          fetchTopCustomers(filters);
        }}
      />
      <div className="chart-wrapper-ranking" ref={chartRef}>
        <Ranking data={topProviders} title="Top providers" height="auto" width='auto' />
        <Ranking data={topCustomers} title="Top customers" height="auto" width='auto' />
      </div>
    </div>
  )
}

export default RankingCharts
